import { ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import { mapState } from 'vuex';
import CreateMailToLink from 'client/util/linkUtils';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';

const mailToLink = orgId => CreateMailToLink('billing@jumpcloud.com', {
  subject: 'My JumpCloud account is in default',
  body: encodeURIComponent(
    `I'd like to chat with someone about my account that is currently in default.\n\nOrganization ID: ${orgId}\nName:\nPhone:\nMethod of payment: {fill in your preferred payment method}\n- - - -\nSuccessfully updated credit cards will be charged with outstanding balances within the next 24 hours and should unlock your admin console immediately.\nWhen paying with a method other than credit card, access to your Admin Portal administration will be restored within 2 business days of successful remediation.\n`,
  ),
});
const settingsModule = StoreModuleMap[ItemTypeConsts.settings];

export default {
  computed: {
    ...mapState(settingsModule, ['orgId']),
    mailToBillingLink() {
      return mailToLink(this.orgId);
    },
  },

  billingLink: KbArticleUrls.billingChargesInvoices,
};
